'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './mail-list.routes';

export class MailListComponent {

  constructor(Auth, dialogs, $uibModal, MailsService, $stateParams, $location, Upload, ContactService, SettingsService, DTOptionsBuilder) {
    'ngInject';
    this.dialogs = dialogs;
    this.$uibModal = $uibModal;
    this.MailsService = MailsService;
    this.ContactService = ContactService;
    this.Upload = Upload;
    this.$stateParams = $stateParams;
    this.Auth = Auth;
    this.$location = $location;

    this.type = $stateParams.type;

    this.selectedVoting = null;
    this.contacts = [];
    this.votings = [{
      _id: null,
      name: "All"
    }];

    this.noData = false;
    this.count = {};

    this.dtOptions = {};

    if (this.type == 'sent') {
      this.dtOptions = DTOptionsBuilder
        .newOptions()
        .withOption('rowGroup', [0])
        .withOption('columnDefs', [ {
          targets: [0],
          visible: false
        } ]);
    }

    SettingsService.getByName({name: 'client'}, settings => {

      this.useSuite = settings.data.useSuite;

      this.MailsService.getByType({type: this.type}, (data) => {
        this.mails = data;

        if (this.mails.length == 0) {
          this.noData = true;
        }

        if (this.type == 'sent') {
          this.mails.forEach(mail => {
            let voting = mail.voting;
            if (voting && voting._id && !this.votings.find(v => v._id == mail.voting._id)) {
              this.votings.push(voting);
            }
          });
        }

        this.filteredMails = this.mails;
      }, err => {
        console.log("Could not retrieve mail lists from server.")
      });

      this.MailsService.query(data => {
        data.forEach(mail => {
          if (mail.type) {
            if (!this.count[mail.type]) {
              this.count[mail.type] = 0;
            }
            this.count[mail.type]++;
          }
        })
      });

    });

  }

  updateFilter() {
    if (!this.selectedVoting) {
      this.filteredMails = this.mails;
    } else {
      this.filteredMails = this.mails.filter(m => m.voting._id == this.selectedVoting);
    }
  }

  send(mail) {

    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'mailComposerSendComponent',
      resolve: {
        config: function() {
          return {
            mail: mail
          }
        }
      },
      size: 'md'
    });

    modalInstance.result.then(
      function (result) {

        let id = result.mailId;
        let cat = result.archiveCategory;

        that.filteredMails = that.filteredMails.filter(function( obj ) {
          return obj._id !== id;
        });

        that.mails = that.mails.filter(function( obj ) {
          return obj._id !== id;
        });

        if (that.filteredMails.length == 0) {
          that.noData = true;
        }

        that.count["draft"]--;
        that.count["sent"]++;

        that.dialogs.notify("Mail has been sent", "The mail has been sent successfully");
      },
      function () { /* cancel */ }
    );

  }

  delete(mail) {
    var that = this;

    var listText = "<br/><br/><b>" + mail.subject + "</b>";

    var dlg = this.dialogs.confirm("Delete Mail?", "Do you really want to delete this mail?" + listText);
    dlg.result.then(() => {
      // OK delete it
      that.MailsService.delete({id: mail._id},
        () => {
          that.filteredMails = that.filteredMails.filter(function( obj ) {
            return obj._id !== mail._id;
          });

          that.mails = that.mails.filter(function( obj ) {
            return obj._id !== mail._id;
          });
          
          that.count[that.type]--;
        },
        err => {
          alert("Could not delete mail");
        });
    }, () => {
      // Cancel
    });
  }

  openRecipientsModal(mail) {
    var that = this;

    let getComposedName = (contact) => {
      let composedName = "";

      if (contact.lastName && contact.firstName) {
        composedName = contact.lastName + ", " + contact.firstName;
        if (contact.middleName)
          composedName += " " + contact.middleName;
      }

      if (contact.company) {
        if (composedName == "")
          composedName += contact.company;
        else
          composedName += "<br/>" + contact.company;
      }

      return composedName || "-";
    };

    let getPrimaryEmail = (contact) => {
      if (!contact || !contact.email || !contact.email.length)
        return "-";

      let email = contact.email.find(email => email.isPrimary) || contact.email[0] || {address:'-'};

      return email.address;
    };

    let openModal = _=> {
      var modalInstance = this.$uibModal.open({
        animation: true,
        component: 'datatableViewer',
        resolve: {
          config: function () {
            return {
              data: mail.recipients.map(email => [that.mapEmailContactName[email] || '(Unknown Contact)', email]) || [],
              settings: {
                "columns": [
                  "Name",
                  "Email"
                ]
              },
              name: mail.subject + " Recipient List"
            }
          }
        },
        size: 'lg'
      });
    };

    if (this.contacts.length) {
        openModal();
    } else {
      let CONTACT_QUERY_METHOD = (this.useSuite) ? "query" : "query";  //TODO: implement querySuite!!!!

      this.ContactService[CONTACT_QUERY_METHOD](contacts => {
        this.contacts = contacts.filter(r => getPrimaryEmail(r) !== "-");
        this.mapEmailContactName = {};
        this.contacts.forEach(contact => {
          this.mapEmailContactName[getPrimaryEmail(contact)] = getComposedName(contact);
        });

        openModal();
      });
    }

  }

  clone(mail) {
    var that = this;

    var listText = "<br/><br/><b>" + mail.subject + "</b>";

    var dlg = this.dialogs.confirm("Clone Mail?", "Do you want to clone this mail?" + listText + "<br/><br/>The mail will be opened in the mail composer after it has been cloned");
    dlg.result.then(() => {

      let clonedMail = angular.copy(mail);

      delete clonedMail._id;
      delete clonedMail.sentDate;
      delete clonedMail.recipients;
      delete clonedMail.meta.creationDate;

      clonedMail.type = 'draft';
      clonedMail.subject += " (Cloned " + new Date().toLocaleString() + ")";

      clonedMail.meta.creationUser = that.Auth.getCurrentUserSync()._id;
      clonedMail.meta.active = true;

      that.MailsService.save(clonedMail,
        (newMail) => {
          that.$location.path("/mail/composer/" + newMail._id);
        },
        err => {
          alert("Could create mail");
        });
    }, () => {
      // Cancel
    });
  }

  openPreviewModal(mail) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'mailComposerPreviewComponent',
      resolve: {
        config: function() {
          return {
            url: '/api/mails/html/'+mail._id,
            title: mail.subject
          }
        }
      },
      size: 'lg'
    });

    modalInstance.result.then(
      function () { /* ok */ },
      function () { /* cancel */ }
    );

  }
}

export default angular.module('conduuApp.mailList', [uiRouter])
  .config(routes)
  .component('mailList', {
    template: require('./mail-list.html'),
    controller: MailListComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/messaging/mail/list/mail-list.component.js